




























































import {Component} from 'vue-property-decorator'
import Vue from 'vue';

import MainNavigation from "../components/MainNavigation.vue";
import PackageListTile from "../components/PackageListTile.vue";
import Package from "@/ts/interfaces/Package";
import PackageDialogStore from "@/ts/stores/PackageDialogStore";
import PackageDialog from "@/components/dialogs/PackageDialog.vue";
import AppPackages from "@/API/AppPackages";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import DeleteDialogStore from "@/ts/stores/DeleteDialogStore";
import ErrorDialog from "@/components/dialogs/ErrorDialog.vue";
import ErrorStore from "@/ts/stores/ErrorStore";

@Component({
    components: {
        MainNavigation,
        PackageListTile,
        PackageDialog,
        DeleteDialog
    }
})

export default class Packages extends Vue {
    packages: Package[] = [];
    toEdit: Package|null = null;

    get displayPackages() {
        return this.packages
    }

    mounted() {
        AppPackages.getAppPackages().then(res => {
            this.packages = res;
        });

        //@ts-ignore:
        let mandate = document.getElementById("group-mandate").firstChild.firstChild.firstChild;
        let packages = document.getElementById("icon-packages");
        let news = document.getElementById("icon-news");
        let settings = document.getElementById("icon-settings");

        //@ts-ignore:
        mandate.style = "color: rgba(0, 0, 0, 0.54)";
        //@ts-ignore:
        packages.style = "color: #81B219";
        //@ts-ignore:
        settings.style = "color: rgba(0, 0, 0, 0.54)";
        //@ts-ignore:
        news.style = "color: rgba(0, 0, 0, 0.54)";
    }

    onPackageClicked(item: Package) {
        this.$router.push({path: '/packages/edit', query: {id: item.id.toString()}});
    }

    //==============================================
    //===========SECTION PACKAGE DIALOG=============
    //==============================================

    openPackageDialog() {
        PackageDialogStore.show()
    }

    onEditPackage(item: Package) {
        PackageDialogStore.showEdit(item)
    }

    onDeletePackage(item: Package) {
        this.toEdit = item;
        DeleteDialogStore.show()
    }

    addPackage(data: any) {
        AppPackages.createPackage(data.name, data.template_packet_id, data.order_index).then(res => {
            this.$router.push({name: 'update', params: {toLocation: 'packages'}});
        })
    }

    editPackage(data: any) {
        AppPackages.updatePackage(data.id, data.name, data.order_index).then(res => {
            this.$router.push({name: 'update', params: {toLocation: 'packages'}});
        })
    }

    deletePackage() {
        DeleteDialogStore.dismiss();
        if (this.toEdit) {
            AppPackages.deletePackage(this.toEdit.id).then(res => {
                this.$router.push({name: 'update', params: {toLocation: 'packages'}});
            }).catch(err => {
                ErrorStore.showError(err.message.description)
            })
        }
    }
}
